var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2,
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "#DB54B3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2,
    width: 17,
    height: 17,
    rx: 8.5,
    stroke: "#DB54B3",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.13 13.1217C14.8265 12.5989 14.3753 11.1196 14.3753 9.1875C14.3753 8.02718 13.9144 6.91438 13.0939 6.09391C12.2735 5.27344 11.1607 4.8125 10.0003 4.8125C8.84002 4.8125 7.72722 5.27344 6.90675 6.09391C6.08628 6.91438 5.62534 8.02718 5.62534 9.1875C5.62534 11.1202 5.17362 12.5989 4.87011 13.1217C4.7926 13.2546 4.75151 13.4056 4.75098 13.5595C4.75045 13.7134 4.79051 13.8646 4.8671 13.9981C4.94369 14.1315 5.05412 14.2424 5.18724 14.3196C5.32037 14.3967 5.47148 14.4374 5.62534 14.4375H7.85714C7.95808 14.9314 8.22651 15.3753 8.61704 15.6941C9.00757 16.0129 9.49622 16.187 10.0003 16.187C10.5045 16.187 10.9931 16.0129 11.3836 15.6941C11.7742 15.3753 12.0426 14.9314 12.1435 14.4375H14.3753C14.5292 14.4373 14.6802 14.3965 14.8132 14.3194C14.9463 14.2422 15.0566 14.1313 15.1332 13.9978C15.2097 13.8644 15.2497 13.7132 15.2492 13.5594C15.2486 13.4055 15.2075 13.2546 15.13 13.1217ZM10.0003 15.3125C9.72899 15.3124 9.46434 15.2282 9.24281 15.0715C9.02128 14.9148 8.85376 14.6933 8.76331 14.4375H11.2374C11.1469 14.6933 10.9794 14.9148 10.7579 15.0715C10.5363 15.2282 10.2717 15.3124 10.0003 15.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionAlert);
export default __webpack_public_path__ + "static/media/action-alert.a8945d33b86bddc9107bc1e060bb227b.svg";
export { ForwardRef as ReactComponent };